import React, { ReactNode, useState } from 'react';
import UserLocation from '../components/user-location/UserLocation';
import UserLocationContext, {
    UserLocationObj,
} from '../components/user-location/UserLocationContext';
import '../i18n';

export default ({ children }: { children: ReactNode }) => {
    // We will default the country to GBP so that if the user location fails to load,
    // or the user has JS disabled they will still see some prices
    const [userLocation, setUserLocation] = useState<UserLocationObj>({
        isFallback: true,
        country: {
            iso_code: 'GB',
        },
    });
    return (
        <UserLocationContext.Provider value={userLocation}>
            <UserLocation setUserLocation={setUserLocation} userLocation={userLocation} />
            {children}
        </UserLocationContext.Provider>
    );
};
